export default __webpack_public_path__ + "static/media/topnav_bg_img.af30db49.png";